import type { NextPage } from "next";
import { useRouter } from "next/router";
import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/containers/specifics/vendors/settings/company_settings/[id]/construction_item_settings/Page";

export const PATH = (companyMasterId: number): string =>
	`/vendors/settings/company_settings/${companyMasterId}/construction_item_settings`;

const CompanySetting: NextPage = () => {
	const router = useRouter();
	const { companyMasterId = null } = router.query;

	if (companyMasterId === null) {
		return null;
	}

	return (
		<>
			<NskHead title="単価一覧" />
			<Component companyMasterId={Number(companyMasterId)} />
		</>
	);
};
export default CompanySetting;
